module.exports = __webpack_public_path__ + "media/images/area/feature/tohoku/related/id/4-0f148ca3166819f2f1d97b915d62c20c.jpg";